(() => {
  const jumpHashes = ['#sb-journal-routes', '#sb-journal-routes-heading'];

  const replaceJumpLocation = (state = null) => {
    if (!window.history || !window.history.replaceState) return;
    window.history.replaceState(state, '', `${window.location.pathname}${window.location.search}`);
  };

  const resetStaleJump = () => {
    const cameFromJournalJump = window.history?.state?.scummyJournalJump === true;
    if (!jumpHashes.includes(window.location.hash) && !cameFromJournalJump) return;

    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    replaceJumpLocation();
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        if ('scrollRestoration' in window.history) {
          window.history.scrollRestoration = 'auto';
        }
      });
    });
  };

  if (!window.scummyJournalJumpBound) {
    window.scummyJournalJumpBound = true;

    document.addEventListener('click', (event) => {
      const jumpLink = event.target.closest('[data-journal-jump]');
      if (!jumpLink) return;

      const destination = document.getElementById('sb-journal-routes');
      if (!destination) return;

      event.preventDefault();

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      destination.scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'start'
      });

      replaceJumpLocation({ scummyJournalJump: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resetStaleJump, { once: true });
  } else {
    resetStaleJump();
  }
})();
